/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 11.1.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Specifies the time context for time-dependent routing (e.g., to account for traffic patterns or time-based access restrictions). Defaults to depart_now for traffic-influenced routing profiles like `auto_traffic`.
 * @export
 * @interface TimeConstraintV1
 */
export interface TimeConstraintV1 {
  /**
   * The type of time constraint: `depart_now` = depart now (current time), `depart_at` = depart at the specified time, `arrive_at` = arrive by the specified time.
   * @type {TimeConstraintV1TypeEnum}
   * @memberof TimeConstraintV1
   */
  type: TimeConstraintV1TypeEnum;
  /**
   * The date and time in `YYYY-MM-DDTHH:MM` format (seconds are accepted, but will be ignored). The date and time are local (civil) time as observed at the location. Required when type is depart_at or arrive_at. Must not be provided for depart_now.
   * @type {string}
   * @memberof TimeConstraintV1
   */
  value?: string;
}

/**
 * @export
 */
export const TimeConstraintV1TypeEnum = {
  DepartNow: "depart_now",
  DepartAt: "depart_at",
  ArriveAt: "arrive_at",
} as const;
export type TimeConstraintV1TypeEnum =
  (typeof TimeConstraintV1TypeEnum)[keyof typeof TimeConstraintV1TypeEnum];

/**
 * Check if a given object implements the TimeConstraintV1 interface.
 */
export function instanceOfTimeConstraintV1(
  value: object,
): value is TimeConstraintV1 {
  if (!("type" in value) || value["type"] === undefined) return false;
  return true;
}

export function TimeConstraintV1FromJSON(json: any): TimeConstraintV1 {
  return TimeConstraintV1FromJSONTyped(json, false);
}

export function TimeConstraintV1FromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TimeConstraintV1 {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"],
    value: json["value"] == null ? undefined : json["value"],
  };
}

export function TimeConstraintV1ToJSON(json: any): TimeConstraintV1 {
  return TimeConstraintV1ToJSONTyped(json, false);
}

export function TimeConstraintV1ToJSONTyped(
  value?: TimeConstraintV1 | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    value: value["value"],
  };
}
